<template>
    <el-container class="unilateral">
        <el-main>
            <div class="unilateral-strategy">
                <el-header class="column-header clearfloat">
                    策略
                    <!-- <el-button class="btn_style" v-if="userLevel == 1" @click="addStrategy('add')">添加策略</el-button> -->
                    <el-dialog title="策略修改/添加" class="add-strategy" :visible.sync="dialogStrategy"> 
                        <el-form label-width="100">
                            <el-form-item label="策略名称">
                                <el-input v-model="StrategyNames"></el-input>
                            </el-form-item>
                            <el-form-item label="是否展示">
                                <el-switch
                                active-text="开" inactive-text="关"
                                v-model="switchFlag1">
                                </el-switch>
                            </el-form-item>
                        </el-form>

                        <div slot="footer" class="dialog-footer">
                            <el-button @click="dialogStrategy = false">取消</el-button>
                            <el-button type="primary" @click="strategySubmit">确定</el-button>
                        </div>
                    </el-dialog>

                    <div class="unilateral-contral float-right" v-if="userLevel == 1">
                        <el-row class="unilater-contral-panel" :gutter="20">
                            <!-- <span>监控</span> -->
                            <span>
                                <span class="contral-strategy-status" :style="{'background-color': strategyStatusChanged(contralStgData)}"
                                @click="contralClickEvent(1)">
                                    策略</span>
                            </span>
                            <span>
                                <span class="contral-strategy-status" :style="{'background-color': strategyStatusChanged(contralApiData)}"
                                @click="contralClickEvent(2)">
                                    API</span>
                            </span>
                            <span>
                                <span class="contral-strategy-status" :style="{'background-color': strategyStatusChanged(contralKData)}"
                                @click="contralClickEvent(3)">
                                    K线</span>
                            </span>
                        </el-row>
                        <div class="unilateral-contral-body" v-if="false">
                            <el-row :gutter="20">
                                <el-col :span="4">
                                    <div class="unilateral-contral-title">
                                        策略
                                    </div>
                                    <ul>
                                        <li class="clear" v-for="(item, index) in contralStgData" :key="index">
                                            <span class="contral-strategy-name">{{item[0]}}</span>
                                            <span class="contral-strategy-status" :style="{'background-color': strategyStatusChanged(item[1])}"></span>
                                        </li>
                                    </ul>
                                </el-col>
                                <el-col :span="4">
                                    <div class="unilateral-contral-title">
                                        API
                                    </div>
                                    <ul>
                                        <li class="clear" v-for="(item, index) in contralApiData" :key="index">
                                            <span class="contral-strategy-name">{{item[0]}}</span>
                                            <span class="contral-strategy-status" :style="{'background-color': strategyStatusChanged(item[1])}"></span>
                                        </li>
                                    </ul>
                                </el-col>
                                <el-col :span="14">
                                    <div class="unilateral-contral-title">
                                        K线contralKData
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </div>

                </el-header>
                <el-row class="unilateral-strategy-header">
                    <el-col class="money_algin_style" v-for="(col, index) in tableRowName" :key="'col_'+index"
                    :style="{'padding-left': '10px'?col.key=='names':'0'}">
                        {{col.title}}
                    </el-col>
                </el-row>
                <el-collapse @change="handleCollapse" v-model="collValue">
                    <StrategyItem  v-for="(item, index) in tableData" :key="'str_'+index" :ref="'collapse'+index"
                    :taskData="item" :uindex="index" :formData="chartDataList" :apiData="apiData" @showEdit="addStrategy" @addTask="showAddTask" :underIndex="index"></StrategyItem>
                </el-collapse>
            </div>
        </el-main>

        <!-- 添加任务弹窗 -->
        <TaskEditDialog ref="taskEditDialog"></TaskEditDialog>

    </el-container>
</template>

<script>
/* eslint-disable */
import Header from "@/components/header/Header.vue";
import Footer from "@/components/Footer/New-footer.vue";
import { get, put, post } from "@/api/index";
import { mapState, mapActions } from "vuex";
import StrategyItem from "@/components/unilateral/Unilateral-task.vue";
import { getApiList, postUnilateralTask } from "@/api/api";
import TaskEditDialog from "@/components/unilateral/Unilateral-task-edit.vue";
import * as dayjs from 'dayjs';

export default {
    components: {
        Header,
        Footer,
        StrategyItem,
        TaskEditDialog
    },
    data: function () {
        var validatePriority = (rule, value, callback) => {// 优先级表单验证
            if (!value) {
                return callback(new Error('优先级不能为空！'));
            }
            if (!Number.isInteger(parseInt(value))) {// 不是数字
                return callback(new Error("请输入数字!"));
            }
            if (Number(value) < 0 || Number(value) > 5) {
                return callback(new Error("请输入0~5之间的数字!"));
            }
            callback();
        };
        var validateApi = (rule, value, callback) => {
            if (!value) return callback(new Error("API不能为空！"));
            callback();
        }

        return {
            tableRowName: [
                {title: '策略名称', key: 'names'},
                {title: '策略状态', key: 'status'},
                {title: '累计收益', key: 'total_eq'},
                {title: '持仓概述', key: 'position'},
                {title: '走势图', key: ''},
                {title: '策略更新时间', key: 'update_time'},
                {title: '最近交易时间', key: 'last_deal'},
                {title: '操作'}
            ],
            tableData: [],
            strategyStatus: ['暂停', '运行'],
            aboutAssets: ['capital', 'cash', 'initial_money', 'equity'],
            formData: {
                "strategyId": '',
                "strategy_id": '',
                "target": 0,
                "names": ""
            },
            dialogStrategy: false,
            switchFlag1: false,
            inputTip: '',
            timer: '',
            skt: '',
            contralStgData: {},
            contralApiData: {},
            contralKData: '',
            dialogType: 'add',
            selectStrategyList: [],
            apiData: [],
            StrategyNames: '',
            addTaskFlag: false,
            addTaskParam: {},
            apilist: [],
            rules: {
                priority: [
                    { validator: validatePriority, trigger: 'blur' }
                ],
                apiId: [
                    { validator: validateApi, trigger: 'blur' }
                ]
            },
            chartDataList: [],
            collValue: '',
            collActivedList: [],
        }
    },
    mounted() {
        this.getStrategy();
        this.createSocket();
        getApiList({'token': this.token}).then(res => {
            if (res.code == 200) {
                this.apilist = res.data;
            } else {
                this.$notify.error({
                    message: res.info,
                    title: '提示',
                    offset: 100
                })
            }
        })
    },
    beforeDestroy() {

    },
    computed: {
        ...mapState([
            'token',
            'userLevel',
            "uniSocket"
        ])
    },
    methods: {
        // Get unilateral strategy 
        getStrategy() {
            var url = this.$url_LN_local + '/get/info/data';
            var param = {
                'token': this.token
            } 

            get(url, param, true).then(res => {
                if (res.code == 200) {
                    this.tableData = res.data;
                    this.selectStrategyList = res.data;
                    // this.$store.commit('setNewStrategyArr', res.data);
                } else {
                    this.$notify.error({
                        message: res.info,
                        title: '提示',
                        offset: 200
                    })
                }
            });
        },

        // Show static data
        showStaicData(sid) {
            this.$store.commit('setUnilateralKey', sid);
            let strategy_static = this.$router.push({
                path: '/unilateral/statistic',
                query: {
                    key: sid
                }
            });
        },


        // Operation the strategy
        operStrategy(flag, sid) {
            let url = this.$url_LN_local + '/put/strategy/state';
            let param = {
                'token': this.token,
                'strategyIds': [sid],
            };

            if (flag == 'start') {
                param['state'] = 1;
            } else if (flag == 'stop') {
                param['state'] = 0;
            }

            put(url, param).then(res => {
                if (res.code === 200) {
                    this.getStrategy();
                } else {
                    this.$notify.error({
                        message: res.info,
                        title: '提示',
                        offset: 200
                    })
                }
            })
        },

        // 输入框 提示
        querySearch(queryString, cb) {
            var query_list = [];
            for (var i=0; i<this.tableData.length; i++) {
                var str_id = this.tableData[i].id;
                var str_name = this.tableData[i].names;
                var show_str = {
                    'value': str_name,
                    'id': str_id
                };
                query_list.push(show_str);
            }
            var results = queryString ? query_list.filter(this.createFilter(queryString)) : query_list;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },

        // 筛选
        createFilter(queryString) {
            return (restaurant) => {
                return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },

        // 输入框 建议事件
        handleSelect(item) {
            this.formData.strategyId = item.id;
        },

        // 策略修改|添加
        strategySubmit() {
            var url = this.$url_LN_local + '/update/strategy';
            this.formData['token'] = this.token;
            this.formData['names'] = this.StrategyNames;
            if (this.switchFlag1) {
                this.formData['target'] = 1;
            } else {
                this.formData['target'] = 0;
            }

            post(url, JSON.stringify(this.formData)).then(res => {
                if (res.code == 200) {
                    this.$notify.info({
                        message: res.info,
                        title: '提示',
                        offset: 100
                    });
                    this.dialogStrategy = false;
                    this.initParam();
                    this.getStrategy();
                } else {
                    this.$notify.error({
                        message: res.info,
                        title: '提示',
                        offset: 100
                    })
                }
            })
        },  

        // 初始化 表单 参数
        initParam() {
            this.formData = {
                "strategyId": '',
                "strategy_id": '',
                "target": 0,
                "names": ""
            };
            this.inputTip = '';
        },
        
        // websocket 初始化
        webSocketInit() {
            this.uniSocket.skt.onopen = this.socketOpen;
            this.uniSocket.skt.onmessage = this.getMsg;
            this.uniSocket.skt.onclose = this.socketClose;
        },

        // websocket 创建
        createSocket() {
            var url = this.$socket_url_ln+"/web/all/data?token="+this.token;
            if (!this.uniSocket.skt) {
                this.uniSocket.skt = new WebSocket(url);
                console.log("websocket connect successfully ", this.uniSocket.skt);
            }
            this.webSocketInit();
        },

        // socket 接收函数
        getMsg(res) {
            var data = JSON.parse(res.data);

            if (!data.hasOwnProperty('code')) {
                // 策略
                this.tableData = data.strategy.strategy;  
                // 监控
                this.contralStgData = data.strategy.monitoring.strategy;
                this.contralApiData = data.strategy.monitoring.api;
                this.contralKData = data.strategy.monitoring.kline;
                // api
                this.apiData = data.api;
            } else {
                this.tableData = data.data.strategy;
                this.apiData = data.task;
                this.handleSData(this.tableData);
            }
        },

        // send 函数
        socketOpen() {

        },

        // socket 关闭函数
        socketClose(e) {
            console.log("webSocket connect close ", e);
        },

        // 策略
        strategyStatusChanged(index) {
            var index = String(index);
            if (index == '1') return '#1aa094';  // 正常
            else if (index == '2') return "#c32e08"; // 异常
            else if (index == '0') return '#333333';
        },

        // 监控显示
        contralClickEvent(index) {
            let strategyContral = this.$router.resolve({
                name: 'strategyContral',
                query: {
                    id: index
                }
            })

            window.open(strategyContral.href, '_blank')
        },

        // 添加策略 触发事件
        addStrategy(tps, id) {
            this.formData = {};
            this.dialogStrategy = true;
            this.dialogType = tps;
            if (tps == 'edit') {
                this.getStategyRep(id);
                this.formData['strategyId'] = id;
            }
        },

        // 获取策略回显
        getStategyRep(id) {
            var url = this.$url_LN_local + "/reproduction/strategy";
            var param = {
                "token": this.token,
                "strategyId": id
            };

            get(url, param).then(res => {
                if (res.code == 200) {
                    this.formData['names'] = res.data.names;
                    this.StrategyNames = res.data.names;
                    this.switchFlag1 = res.data.target;
                } else {
                    this.$notify.error({
                        message: res.info,
                        title: "提示",
                        offset: 200
                    })
                }
            })
        },

        //打开添加任务弹窗
        showAddTask(id, names){
            let addTaskParam = {};
            addTaskParam['strategyId'] = id;
            addTaskParam['names'] = names;
            // this.addTaskFlag = true;
            this.$refs.taskEditDialog.initDialog('', 'add', addTaskParam);
        },

        // 策略数据处理
        handleSData(data) {
            let chartData = [];
            for (let i=0; i<data.length; i++) {
                let i_data = data[i];
                chartData.push(JSON.parse(i_data.chart_data));
            }
            chartData.forEach(item => {
                const lastDay = item[1][item[1].length - 1]
                for(let i = 1; i <= 7; i++) {
                    item[1].push(dayjs(lastDay).add(i, 'day').format('YYYY-MM-DD'))
                }
            })
            this.chartDataList = chartData;

            this.$store.commit('setUnilSChartData', chartData);
        },
        // 点击展示事件
        handleCollapse(e) {
           
            for (let i of e) {
                if (i) {
                    // this.collActivedList.push(i);
                    this.$refs[i][0].renderChild(true);
                }
            }
            // for (let j of this.collActivedList) {
            //     if (e.indexOf(j) !== -1) {
            //         this.$refs[j][0].renderChild(false);
            //         this.collActivedList.remove(j);
            //     }
            // }
            // console.log('collapse', this.collActivedList, e);
        }
    }
}
</script>

<style lang="scss">
.unilateral {
    // padding-top: 30px;
    background-color: #252425;
    color: #a8a7a9;
    .el-dialog__header {
        background-color: #fff !important;
        padding: 10px 0 !important;
        border-bottom: 1px solid #eaeaea;
    }
    .el-form{
        .el-select {
            width: 100%;
        }
    }

    .unilateral-addtask {
        .el-dialog__header {
            background-color: #fff !important;
            padding: 10px 0 !important;
            border-bottom: 1px solid #eaeaea;
        }
        .el-select{
            width: 100%;
        }
    }

    .el-collapse-item__header {
        height: auto;
        font-weight: normal;
    }

    .el-loading-spinner .path {
        stroke: #585858;
    }

    .el-collapse {
        border-color: #2a2d2e !important;
    }

    .money_algin_style {
        text-align: left;
        flex: 1;
        padding: 0 5px;
    }

    .unilateral-contral {
        .unilater-contral-panel {
            padding: 0 10px;
            background-color: #1e1e1e;
            margin: 0 !important;
            text-align: left;
            .contral-strategy-status{
                // width: 13px;
                // height: 13px;
                border-radius: 3px;
                display: inline-block;
                text-align: center;
                color: #fff;
                vertical-align: middle;
                margin-left: 5px;
                padding: 2px 5px;
                font-size: 12px;
                background-color: #1aa094;
            }

            .contral-strategy-status:hover{
                cursor: pointer;
            }

            span{
                display: inline-block;
                vertical-align: middle;
            }
        }
        
        .unilateral-contral-body {
            padding: 5px 10px;
            .el-row{
                margin: 0 !important;
                .el-col{
                    background-color: #323535;
                    padding: 0 !important;
                    margin: 0 5px;
                }
                .unilateral-contral-title{
                    background-color: #1e1e1e;
                }
                ul {
                    text-align: left;
                    li {
                        padding: 3px 10px;
                        .contral-strategy-status{
                            width: 13px;
                            height: 13px;
                            border-radius: 3px;
                            display: inline-block;
                            text-align: center;
                            color: #fff;
                            vertical-align: middle;
                            float: right;
                        }
                    }
                    li:hover {
                        background-color: #1e1e1e;
                    }
                }
            }
        }
    }
    

    .unilateral-strategy {
        .unilateral-strategy-table {
            width: 100%;
            thead th{
                padding: 10px;
            }
        }

        .unilateral-strategy-header {
            padding: 10px 0;
            display: flex;
            background-color: #2a2d2e;
        }
        .el-collapse {
            padding-bottom: 60px;
        }
    }

    .add-strategy {
        
        .el-dialog__header {
            text-align: center;
            padding: 10px 0 !important;
            background-color: #fff !important;
            box-sizing: border-box;
            border-bottom: 1px solid #dcdbdc;
            span {
                background-color: #fff;
                border-color: #fff;
            }
        }
        .el-dialog__body {
            padding: 10px !important;
            .el-form-item__content{
                margin-left: 100px;
            }
        }
    }

    .el-row{
        margin: 0 !important;
    }

    .strage_status {
        border-radius: 3px;
        color: #fff;
        padding: 3px 6px;
        box-sizing: border-box;
        display: inline-block;
    }

    .btn_style {
        border-radius: 3px;
        padding: 5px 10px;
        box-sizing: border-box;
        display: inline-block; 
        background-color: #333333;
        border-color: #333333;
        margin: 0 5px;
    }

    .el-popover {
        width: 240px !important;
    }

    .el-main {
        background-color: #252425;
        // padding: 15px 0;
        .unilateral-contral {
            // margin-bottom: 20px;
            background-color: #2a2d2e;
        }

        .el-header {
            background-color: #1e1e1e;
            text-align: left;
            padding: 5px 10px;
            vertical-align: middle;
            display: flex;
            align-items: center;
        }

        .el-table {
            background-color: #2a2d2e;

            .table-btn {
                background-color: #333333;
                border-color: #333333;
                padding: 8px 14px;
            }

            .el-button {
                margin-right: 5px;
            }

            .el-table__header-wrapper {
                background-color: transparent !important;
            }
            th.is-leaf, td {
                background-color: #2a2d2e;
                border-bottom: 1px solid #3a393a;
            }

            th, tr {
                background-color: transparent;
            }

            th {
                div {
                    text-align: left;
                }
            }

            tbody {
                tr:hover {
                    background-color: transparent;
                    td {
                        color: #999999;
                        background-color: transparent;
                    }
                }

            }
        }

        .el-table--border::after, .el-table--group::after, .el-table::before {
            content: '';
            position: absolute;
            background-color: transparent;
            z-index: 1;
        }
    }
}
</style>
